// Российские часовые пояса для выбора времени звонка. Смещения фиксированные —
// перевода часов в РФ нет, поэтому арифметика по offset безопасна круглый год.
// В интерфейсе показываем город-«столицу» пояса и сдвиг от Москвы, а не GMT+N.
export const RU_TIMEZONES = [
    {id: 'Europe/Kaliningrad', city: 'Калининград', label: 'Калининград (МСК−1)', offset: 2},
    {id: 'Europe/Moscow', city: 'Москва', label: 'Москва (МСК)', offset: 3},
    {id: 'Europe/Samara', city: 'Самара', label: 'Самара (МСК+1)', offset: 4},
    {id: 'Asia/Yekaterinburg', city: 'Екатеринбург', label: 'Екатеринбург (МСК+2)', offset: 5},
    {id: 'Asia/Omsk', city: 'Омск', label: 'Омск (МСК+3)', offset: 6},
    {id: 'Asia/Krasnoyarsk', city: 'Красноярск', label: 'Красноярск (МСК+4)', offset: 7},
    {id: 'Asia/Irkutsk', city: 'Иркутск', label: 'Иркутск (МСК+5)', offset: 8},
    {id: 'Asia/Yakutsk', city: 'Якутск', label: 'Якутск (МСК+6)', offset: 9},
    {id: 'Asia/Vladivostok', city: 'Владивосток', label: 'Владивосток (МСК+7)', offset: 10},
    {id: 'Asia/Magadan', city: 'Магадан', label: 'Магадан (МСК+8)', offset: 11},
    {id: 'Asia/Kamchatka', city: 'Камчатка', label: 'Камчатка (МСК+9)', offset: 12},
];

export function findRuTimezone(id) {
    return RU_TIMEZONES.find(z => z.id === id) || null;
}

// Пояс юзера по умолчанию: точное совпадение IANA-имени браузера, иначе по
// текущему смещению (Новосибирск попадёт в «Красноярск (МСК+4)» — тот же час),
// для не-российских поясов — Москва.
export function detectRuTimezone() {
    const byName = findRuTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
    if (byName) return byName;
    const offsetMinutes = -new Date().getTimezoneOffset();
    return RU_TIMEZONES.find(z => z.offset * 60 === offsetMinutes)
        || findRuTimezone('Europe/Moscow');
}
